export const FEEDBACK_STATE_HIDDEN = "hidden";
export const FEEDBACK_STATE_PROMPT = "prompt";
export const FEEDBACK_STATE_THANKS = "thanks";
export const FEEDBACK_STORAGE_PREFIX = "ai-triage-feedback:";
export const FEEDBACK_THANKS_VISIBLE_MS = 2200;
export const FEEDBACK_REVEAL_DELAY_MS = 3500;
export const FEEDBACK_RATING_POSITIVE = "positive";
export const FEEDBACK_RATING_NEGATIVE = "negative";
export const FEEDBACK_RATING_DISMISSED = "dismissed";

export function feedbackStorageKey(chatId) {
  return `${FEEDBACK_STORAGE_PREFIX}${chatId}`;
}

export function readStoredFeedback(chatId, storage = window.localStorage) {
  if (!chatId) {
    return null;
  }

  try {
    return storage.getItem(feedbackStorageKey(chatId));
  } catch {
    return null;
  }
}

export function writeStoredFeedback(
  chatId,
  rating,
  storage = window.localStorage
) {
  if (!chatId) {
    return;
  }

  try {
    storage.setItem(feedbackStorageKey(chatId), rating);
  } catch {
    // Private mode / quota must not block the server write-once path.
  }
}

export function shouldRevealFeedbackPrompt({
  feedbackState,
  chatId,
  alreadySubmitted = false,
  storage = window.localStorage,
} = {}) {
  if (feedbackState !== FEEDBACK_STATE_HIDDEN) {
    return false;
  }
  if (alreadySubmitted) {
    return false;
  }
  if (chatId && readStoredFeedback(chatId, storage)) {
    return false;
  }
  return true;
}
